/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { CmsContent } from '@/extensions/nemesis/lib/cms.server';

/**
 * Minimal announcement-line renderer for the CMS load-test integration seam. Deliberately tiny —
 * this is not a merchant-facing content slot, just enough DOM to exercise the loader wiring and
 * edge cache. Renders nothing when the vendor call fails soft to no banners.
 */
export function CmsAnnouncementSlot({ content }: { content: CmsContent }) {
    const banner = content.banners[0];
    if (!banner) {
        return null;
    }
    return <p className="section-container py-2 text-center text-sm text-muted-foreground">{banner.headline}</p>;
}
